export const ANIMATION_DURATION_MS = 160;
export const DEFAULT_Z_INDEX = 50;
